import {FormValues, IFilter, PaymentOptions} from "../../../../types";
import {useEffect, useState} from "react";
import useGetMe from "../../../../../../hooks/useCurrentUser";
import moment, {Moment} from "moment/moment";
import {DatePicker, Row} from "antd";
import {Container, Label} from "../../../../styles";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";
import {Field, Form, Formik} from "formik";
import {Button, Col} from "../../../../billingPanel/components/filter/styles";
import Select from "antd/lib/select";
import SignaturesService from "../../service/SignaturesService";
import { can, PortalPermissions } from "../../../../../../config/permissions";


export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const {getFilters} = props
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const user = useGetMe()
  const {MonthPicker} = DatePicker;
  const signatureService = new SignaturesService();

  const getInitialValue = (): FormValues => {
    const today = new Date();
    return {
      month: today.getMonth() + 1,
      year: today.getFullYear(),
      merchantId: "",
      billingType: -1,
      payed: -1,
    };
  };

  useEffect(() => {
    getSignatures(getInitialValue());
  }, []);

  const getSignatures = async (submit: any) => {
    if (submit.month == "") {
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      submit.month = currentMonth;
    }

    if (submit.year == "") {
      const today = new Date();
      const currentYear = today.getFullYear();
      submit.year = currentYear;
    }

    getFilters(submit);
    return submit;
  };

  const handleMonthChange = (setFieldValue: (field: string, value: any) => void) =>
    (date: Moment | null) => {
      if (date) {
        setFieldValue('month', date.month() + 1);
        setFieldValue('year', date.year());
      } else {
        setFieldValue('month', '');
        setFieldValue('year', '');
      }
    };

 const handleDownload = async (filter?: FormValues) => {
  try {
    setIsLoading(true);

    const response = await signatureService.downloadBillingPanelXls(filter);

    if (response) {
      const objectUrl = window.URL.createObjectURL(response);

      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = "Det. Produtos Contratados.xlsx";

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};

  const options: PaymentOptions[] = [
    {label: "Status Pagamento", value: -1},
    {label: "Pendente", value: 0},
    {label: "Pago", value: 1}
  ];

  return (
    <>
      {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
        <>
          <Container style={{padding: "0px"}}>
            <LoadingOverlay show={isLoading} relative/>

            <Row>
              <Label>Filtrar por:</Label>
            </Row>

            <Formik
              initialValues={getInitialValue()}
              onSubmit={async (values: any) => {
                await getSignatures(values);
              }}>
              {({setFieldValue, values}) => (
                <Form>
                  <Row gutter={16}>
                    <MonthPicker
                      style={{width: "12.4rem", marginBottom: "0.8rem"}}
                      placeholder={"Selecione o mês e ano"}
                      format={"MM/YYYY"}
                      value={values.month && values.year ?
                        moment(`${values.year}-${values.month.toString().padStart(2, '0')}-01`) :
                        null}
                      onChange={handleMonthChange(setFieldValue)}
                      allowClear={true}
                    />

                    <Col>
                      <Field
                        type="text"
                        name="merchantId"
                        placeholder="Cód. Lojista"
                      />
                    </Col>

                    <Col>
                      <Select
                        value={values.billingType}
                        style={{ width: "100%" }}
                        onChange={(value) => setFieldValue("billingType", value)}
                        options={[
                          {value: -1, label: "Produto"},
                          {value: 1, label: "POS Garantida"},
                          {value: 2, label: "Aluguel de POS"},
                          {value: 3, label: "PDV"},
                          {value: 4, label: "Chargeback"},
                          {value: 5, label: "Cobrança Pontual"}
                        ]}
                      />
                    </Col>

                    <Col>
                      <Select
                        value={values.payed}
                        style={{width: "100%" }}
                        onChange={(value) => setFieldValue("payed", value)}
                        options={options}
                      />
                    </Col>

                    <Col>
                      <Button
                        htmlType="submit"
                      >
                        Consultar
                      </Button>
                    </Col>
                     {can(PortalPermissions.cobrancas.produtosContratados.exportar) && (
                       <Button
                        onClick={() => handleDownload(values)}
                        style={{ width: '180px', alignSelf: 'start' }}
                      >
                        Download Xlsx
                      </Button>
                     )}
                  </Row>
                </Form>
              )}
            </Formik>
          </Container>
        </>
      )}
    </>
  )
}
